import { render, staticRenderFns } from "./BearAdminView.vue?vue&type=template&id=3faaedcc&"
import script from "./BearAdminView.vue?vue&type=script&lang=js&"
export * from "./BearAdminView.vue?vue&type=script&lang=js&"
import style0 from "./BearAdminView.vue?vue&type=style&index=0&id=3faaedcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports